export default ({ schedulerReact }) => ({
  styled: {
    position: 'relative',
    '-moz-appearance': 'none',
    '-webkit-appearance': 'none',
    appearance: 'none',
    borderStyle: 'solid',
    borderRadius: 3,
    borderWidth: 1,
    height: 34,
    background: 'transparent',
    padding: [0, 5],
    boxSizing: 'border-box',
    lineHeight: '32px',
    borderColor: schedulerReact.toggleBorderColor,
    marginBottom: 20,
    fontSize: 14,
    '&::-moz-focus-inner': {
      border: 0
    },
    '&::-ms-expand': {
      display: 'none'
    },
    option: {
      fontWeight: 'normal'
    },
    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor: schedulerReact.disabledBackgroundColor,
      color: schedulerReact.disabledTextColor,
      opacity: 1
    }
  },
  label: {
    display: 'inline'
  }
});
